import React, { useEffect, useState, useRef } from "react";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";

function EmailStatusReport() {
  const token = localStorage.getItem("token");

  const [emailStatusData, setEmailStatusData] = useState([]);



  const getNotificationDelivery = async () => {
    if (!token) {
      toast.error("Unauthorized. Please log in.");
      return;
    }
    try {
      const response = await get("Notification/notificationDeliveries", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        setEmailStatusData(response);
      } else {
        toast.error("Failed to fetch.");
      }
    } catch (error) {
      console.error("Error fetching:", error);
      toast.error("Error fetching.");
    }
  };

  useEffect(() => {
    getNotificationDelivery();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "mrt-row-numbers",
        header: "Sr No.",
        enableColumnOrdering: false,
        enableEditing: false, 
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: "subject",
        header: "Subject",
        // size: 300,
      },
      {
        accessorKey: "receipentName",
        header: "Recipient Name",
        // size: 150,
      },
      {
        accessorKey: "receipentEmail",
        header: "Recipient Email",
        // size: 200,
      },
      {
        accessorKey: "errorMessage",
        header: "System Response",
        // size: 250,
        Cell: ({ cell }) => cell.getValue() || "Success!",
      },
      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ cell }) => 
          cell.getValue() === "Sent" ? (
            <i className="fa fa-check-circle text-success fs-8"></i>
          ) : (
            <i className="fa fa-circle-xmark text-danger fs-8"></i>
          ),
      },
    ],
    []
  );

  const exportToExcel = () => {
    const filteredData = emailStatusData.map((row, index) => ({
      "Sr No": index + 1,
      Subject: row.subject,
      "Recipient Name": row.receipentName,
      "Recipient Email": row.receipentEmail,
      "System Response": row.errorMessage || "Success!",
      Status: row.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "EmailStatus");
    XLSX.writeFile(workbook, "EmailStatus.xlsx");
  };

  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
    });
  };

  const exportToPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;

    const roleId = localStorage.getItem("roleId");
    const orgLogoPath = localStorage.getItem("organizationLogoPath");
    const centerLogoPath = localStorage.getItem("centerLogoPath");
    const orgLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${orgLogoPath}`;
    const centerLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${centerLogoPath}`;

    let logoToUse = logo; // Default imported logo
    const sidebarLogoUrl =
      roleId == "2" ? orgLogo : roleId == "3" ? centerLogo : null;

    if (sidebarLogoUrl) {
      try {
        logoToUse = await loadImage(sidebarLogoUrl);
      } catch (error) {
        console.warn(
          "Failed to load sidebar logo, falling back to default.",
          error
        );
      }
    }

    // doc.addImage(logoToUse, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Email Delivery Status";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = columns.filter(
      (column) => column.accessorKey !== "actions" && column.accessorKey !== "mrt-row-numbers"
    );

    const headers = ["Sr No.", ...includedColumns.map((col) => col.header)];

    const bodyData = emailStatusData.map((row, index) => {
      return [
        index + 1,
        row.subject,
        row.receipentName,
        row.receipentEmail,
        row.errorMessage || "Success!",
        row.status,
      ];
    });

    doc.autoTable({
      head: [headers],
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("EmailStatus.pdf");
  };



  return (
    <>
      <div className="">
        <div className="">
          <div className="page-header d-flex mb-2">
            <h2 className="page-heading fs-7">Email Delivery Status</h2>
            </div>
            <CustomDatatableGrid
              columns={columns}
              data={emailStatusData}
              onExportExcel={exportToExcel}
              onExportPDF={exportToPDF}
              initialState={{
                  columnPinning: { right: ["actions"] },
                }}
            />
        </div>
      </div>
    </>
  );
}

export default EmailStatusReport;
